
import React from "react";
import FinanceiroHeader from "@/components/financeiro/FinanceiroHeader";

const RelatoriosHeader = () => {
  return (
    <div className="flex flex-col mb-6">
      <div className="mb-4">
        <h1 className="text-2xl font-normal text-gray-700 mb-1">Financeiro</h1>
        <p className="text-sm text-gray-500 mt-1 opacity-75">
          Relatórios financeiros e análises
        </p>
      </div>
    </div>
  );
};

export default RelatoriosHeader;
